function importAllImages(r) {
    let images = {}
    r.keys().map((item, index) => {
        images[item.replace('./', '').replace(/\.(png|jpe?g|svg)$/, '')] = r(item).default
    })
    return images
}

const images = importAllImages(require.context('./img', false, /\.(png|jpe?g|svg)$/))



export const Radiobutton = ({key, id, name, number, label, componentName, answersOnQuestions, img, setAnswersOnQuestions, index}) => {

    const changeHandler = (e) => {
            let target = e.target

            localStorage.setItem(componentName, target.id)

            setAnswersOnQuestions((answersOnQuestionsOld) => {
                const answersOnQuestionsDraft = {...answersOnQuestionsOld}
                answersOnQuestionsDraft[componentName] = target.id

                return answersOnQuestionsDraft
            })
          },
        isRadioChecked = answersOnQuestions[componentName] === `body-type_${index}`


    return (<div className="body-type-radio" key={key}>
        <input id={`body-type_${index}`}
               type={'radio'}
               name={componentName}
               checked={isRadioChecked}
               onChange={changeHandler}
        />
        <label for={`body-type_${index}`}>
            <span>
                {label}
            </span>
            <img src={images[img]} alt=""/>
        </label>
    </div>)

}
